var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
var EmptyPage = function (props) {
    var _a = useState(false), adding = _a[0], setAdding = _a[1];
    return (_jsxs(_Fragment, { children: [adding && props.addForm({ onCancel: function () { return setAdding(false); } }), !adding &&
                _jsx("div", __assign({ style: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'left', color: 'black', paddingTop: '40px' } }, { children: _jsx("div", { children: props.description }) }))] }));
};
export default EmptyPage;
